import { render } from "./FindTravellPartner.vue?vue&type=template&id=08c312c8"
import script from "./FindTravellPartner.vue?vue&type=script&lang=js"
export * from "./FindTravellPartner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__